export const tag = {
  contacts: 'CONTACTS',
  user: 'USER',
  fileShare: 'FILE_SHRE',
  invites: 'INVITES',
}
export const tagArray = [tag.contacts, tag.user, tag.fileShare, tag.invites]
